import { AboyeurPluginNamed } from '@ifood/aboyeur';
import FasterAnalytics, { FasterConfiguration, EventBuilder } from '@ifood/faster-analytics';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["revision"];
var NAME = 'Faster';
var EVENT_PREFIX = 'aboyeur_';
var MINIMUM_ENTITY_LENGTH = 4;
var ERROR = {
  CONFIG: "Misconfigured " + NAME + " plugin metadata",
  MINIMUM_ENTITY_LENGTH: "Entity must contain at least " + MINIMUM_ENTITY_LENGTH + " characters"
};
var DEFAULT_REVISION = 0;
var MANDATORY_FASTER_CONFIG_KEYS = ['apiKey', 'version', 'secret'];
function isFasterMetadata(metadata) {
  if (!('faster' in metadata)) {
    return false;
  }
  var faster = metadata.faster;
  if (typeof faster !== 'object' || !faster) {
    return false;
  }
  return MANDATORY_FASTER_CONFIG_KEYS.every(function (key) {
    return Object.prototype.hasOwnProperty.call(faster, key);
  });
}
var expectedTypes = ['string', 'number', 'boolean'];
function isSanitized(data) {
  return expectedTypes.includes(typeof data);
}
function sanitize(data) {
  if (!isSanitized(data)) {
    return JSON.stringify(data);
  }
  return data;
}
var FasterPlugin = /*#__PURE__*/function (_AboyeurPluginNamed) {
  _inheritsLoose(FasterPlugin, _AboyeurPluginNamed);
  function FasterPlugin() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _AboyeurPluginNamed.call.apply(_AboyeurPluginNamed, [this].concat(args)) || this;
    _this.instance = void 0;
    _this._prefix = void 0;
    return _this;
  }
  var _proto = FasterPlugin.prototype;
  _proto.initialize = function initialize() {
    var metadata = this.metadata;
    if (!isFasterMetadata(metadata)) {
      throw new Error(ERROR.CONFIG);
    }
    var _metadata$faster = metadata.faster,
      apiKey = _metadata$faster.apiKey,
      version = _metadata$faster.version,
      secret = _metadata$faster.secret,
      embedded = _metadata$faster.embedded,
      _metadata$faster$pref = _metadata$faster.prefix,
      prefix = _metadata$faster$pref === void 0 ? true : _metadata$faster$pref;
    this._prefix = prefix;
    var fasterConfig = new FasterConfiguration(apiKey, secret, {
      appVersion: version
    });
    FasterAnalytics.configure(fasterConfig);
    if (embedded && embedded.externalSessionId && embedded.externalDeviceId) {
      var externalDeviceId = embedded.externalDeviceId,
        externalSessionId = embedded.externalSessionId;
      this.instance = FasterAnalytics.startEmbedded(externalDeviceId, externalSessionId);
    } else {
      this.instance = FasterAnalytics.start();
    }
  };
  _proto.getRevision = function getRevision(options) {
    if (!isFasterMetadata(this.metadata)) {
      return DEFAULT_REVISION;
    }
    var metadata = options.metadata;
    var eventRevision = metadata.event.revision;
    var instanceRevision = metadata.instance.revision;
    var globalRevision = this.metadata.faster.revision;
    var revision = Number(eventRevision || instanceRevision || globalRevision);
    return isNaN(revision) ? DEFAULT_REVISION : revision;
  };
  _proto.sendEvent = function sendEvent(options) {
    var _this$instance;
    var label = options.label,
      entity = options.entity,
      feature = options.feature,
      metadata = options.metadata;
    var fasterMetadata = _extends({}, metadata.instance, metadata.event);
    if (!this._prefix && entity.length < MINIMUM_ENTITY_LENGTH) {
      throw new Error(ERROR.MINIMUM_ENTITY_LENGTH);
    }
    var prefix = this._prefix ? EVENT_PREFIX : '';
    var revision = this.getRevision(options);
    var eventBuilder = new EventBuilder("" + prefix + entity, revision);
    eventBuilder.dimension('feature', sanitize(feature));
    eventBuilder.dimension('label', sanitize(label));
    var otherDimensions = _objectWithoutPropertiesLoose(fasterMetadata, _excluded);
    Object.entries(otherDimensions).forEach(function (_ref) {
      var key = _ref[0],
        value = _ref[1];
      eventBuilder.dimension(key, sanitize(value));
    });
    var event = eventBuilder.build();
    (_this$instance = this.instance) == null ? void 0 : _this$instance.event.register(event);
  };
  _proto.onMetadataChange = function onMetadataChange() {
    var _this2 = this;
    if (!isFasterMetadata(this.metadata)) {
      return;
    }
    var faster = this.metadata.faster;
    if (!faster.metadata) {
      return;
    }
    var _faster$metadata = faster.metadata,
      _faster$metadata$sess = _faster$metadata.session,
      session = _faster$metadata$sess === void 0 ? {} : _faster$metadata$sess,
      _faster$metadata$devi = _faster$metadata.device,
      device = _faster$metadata$devi === void 0 ? {} : _faster$metadata$devi;
    Object.entries(session).forEach(function (_ref2) {
      var _this2$instance;
      var key = _ref2[0],
        value = _ref2[1];
      (_this2$instance = _this2.instance) == null ? void 0 : _this2$instance.session.putProperty(key, sanitize(value));
    });
    Object.entries(device).forEach(function (_ref3) {
      var _this2$instance2;
      var key = _ref3[0],
        value = _ref3[1];
      (_this2$instance2 = _this2.instance) == null ? void 0 : _this2$instance2.device.putProperty(key, sanitize(value));
    });
  };
  return FasterPlugin;
}( /*#__PURE__*/AboyeurPluginNamed(NAME));

export { FasterPlugin };
//# sourceMappingURL=aboyeur-plugin-faster.esm.js.map
